import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Translate } from "../../../../Enums/Tranlate";
import Loader from "../../../../common/Loader";
import RoleService from "../../../../../services/RoleService";
import "../style.scss";

const AddPermission = () => {
	const [formData, setFormData] = useState({
		name: "",
		isActive: true,
	});
	const rolesFun = ["add", "edit", "view", "delete"];
	const [loading, setLoading] = useState(false);
	const [rolesData, setRolesData] = useState([]);
	const navigate = useNavigate();
	const location = useLocation();
	const roleService = new RoleService();
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state?.auth.lang);
	const isExist = (data) => Auth?.roles?.includes(data);
	let id = location?.state?.id;

	useEffect(() => {
		setLoading(true);
		let requests = [roleService.getModule()];
		if (!!location?.state?.id)
			requests = [
				roleService.getModule(),
				roleService.find(location?.state?.id),
			];
		Promise.all(requests).then((res) => {
			let response1 = [];
			if (res[0]?.status) {
				response1 = res[0]?.data?.data?.data
					// ?.filter((res) => res?.isActive)
					?.map((rol) => {
						return {
							...rol,
							add: false,
							edit: false,
							delete: false,
							view: false,
							name: rol?.name?.toLowerCase(),
							displayName: rol?.displayName
								?.toLowerCase()
								.replaceAll(" ", "_")
								.replaceAll("_&", ""),
							role_sub_modules: !rol?.role_sub_modules?.length
								? []
								: rol?.role_sub_modules
										// ?.filter((res) => res?.isActive)
										?.map((child) => {
											return {
												...child,
												add: false,
												edit: false,
												delete: false,
												view: false,
												name: child?.name?.toLowerCase(),
												displayName: child?.displayName
													?.toLowerCase()
													.replaceAll(" ", "_")
													.replaceAll("_&", ""),
											};
										}),
						};
					});
			}
			if (!!location?.state?.id && res[1]?.status) {
				let resFind = res[1]?.data?.data;
				setFormData({
					name: location?.state?.name,
				});
				response1 = resFind?.map((info) => {
					return {
						...info?.role_module,
						displayName: info?.role_module?.displayName
							?.toLowerCase()
							.replaceAll(" ", "_")
							.replaceAll("_&", ""),
						add: info?.can_add,
						edit: info?.can_update,
						delete: info?.can_delete,
						view: info?.can_view,
						role_sub_modules: !!info?.role_module?.role_sub_modules?.length
							? info?.role_module?.role_sub_modules?.map((child) => {
									return {
										...child,
										add: child?.table_roles[0]?.can_add,
										edit: child?.table_roles[0]?.can_update,
										delete: child?.table_roles[0]?.can_delete,
										view: child?.table_roles[0]?.can_view,
									};
							  })
							: [],
					};
				});
			}

			setRolesData(
				response1?.sort((a, b) => {
					const contentA = a.role_sub_modules || [];
					const contentB = b.role_sub_modules || [];

					if (contentA.length === 0 && contentB.length !== 0) return -1;
					if (contentA.length !== 0 && contentB.length === 0) return 1;
					return contentA.length - contentB.length;
				})
			);
			setLoading(false);
		});
	}, []);

	const onSubmit = (e) => {
		e.preventDefault();

		let permissions = rolesData?.flatMap((res) => {
			const parentPermission = {
				role_module_id: res?.id,
				can_view: res?.view,
				can_add: res?.add,
				can_update: res?.edit,
				can_delete: res?.delete,
			};
			const childPermissions =
				res?.role_sub_modules?.map((child) => ({
					role_sub_module_id: child?.id,
					role_module_id: res?.id,
					can_view: child?.view,
					can_add: child?.add,
					can_update: child?.edit,
					can_delete: child?.delete,
				})) || [];

			return [parentPermission, ...childPermissions];
		});
		let data = {
			name: formData?.name,
			admin_role: permissions,
		};

		if (!!location?.state?.id) {
			roleService.update(location?.state?.id, data).then((res) => {
				if (res?.status === 200) {
					toast.success(res?.data?.message);
					navigate("/roles");
				}
			});
		} else {
			roleService.create(data).then((res) => {
				if (res?.status === 201) {
					toast.success(res?.data?.message);
					navigate("/roles");
				}
			});
		}
	};

	if (loading) {
		return (
			<Card style={{ height: "300px" }}>
				<Card.Body>
					<Loader />
				</Card.Body>
			</Card>
		);
	}
	return (
		<>
			<div
				className="d-flex align-items-center"
				style={{ gap: "8px", margin: "12px 0 32px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					className="button-back"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/roles")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!!id ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
					{Translate[lang]?.role}
				</label>

				{/* <Form.Check
					type="switch"
					id="custom-switch"
					checked={formData?.isActive}
					onChange={(e) =>
						setFormData({ ...formData, isActive: e.target.checked })
					}
				/> */}
			</div>
			<form onSubmit={onSubmit}>
				<div>
					<div className="rules">
						<div className="mb-4 w-50">
							<input
								type="text"
								value={formData.name}
								name="name"
								style={{
									height: "44px",
									borderRadius: "10px",
									border: "1px solid rgba(205, 206, 215, 1)",
									padding: "0 14px",
								}}
								className="w-100"
								required
								placeholder={Translate[lang]?.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target?.value })
								}
							/>
						</div>
						<Row>
							{rolesData?.map((rul, index) => {
								return (
									<Col md={6} key={index}>
										{!!rul?.role_sub_modules?.length ? (
											<div>
												<div className="rul-div">
													<div className="title-bg rul-title">
														<p>
															{Translate[lang][rul?.displayName] ||
																rul?.displayName}
														</p>
														<div className="rolesFun">
															{rolesFun?.map((roleFun) => {
																return (
																	<label className="mb-0" key={roleFun}>
																		<input
																			className={
																				lang === "en" ? "mr-2" : "me-2"
																			}
																			type="checkbox"
																			name={`${roleFun}_${rul?.name}`}
																			checked={rul[roleFun]}
																			onChange={(e) => {
																				setRolesData((prev) =>
																					prev?.map((obj) =>
																						obj.id === rul?.id
																							? {
																									...obj,
																									[roleFun]: e.target?.checked,
																									role_sub_modules:
																										obj?.role_sub_modules?.map(
																											(res) => ({
																												...res,
																												[roleFun]:
																													e.target?.checked,
																											})
																										),
																							  }
																							: obj
																					)
																				);
																			}}
																		/>{" "}
																		{Translate[lang][roleFun]}
																	</label>
																);
															})}
														</div>
													</div>
													<div className="rul-details">
														{rul?.role_sub_modules?.map((cont) => {
															return (
																<div className="rul-title">
																	<p>
																		{Translate[lang][cont?.displayName] ||
																			cont?.displayName}
																	</p>
																	<div className="rolesFun">
																		{rolesFun?.map((roleFun) => {
																			return (
																				<label className="mb-0" key={roleFun}>
																					<input
																						className={
																							lang === "en" ? "mr-2" : "me-2"
																						}
																						type="checkbox"
																						checked={cont[roleFun]}
																						name={`${roleFun}_${rul?.name}`}
																						onChange={(e) => {
																							setRolesData((prev) =>
																								prev?.map((obj) =>
																									obj.id === rul?.id
																										? {
																												...obj,
																												[roleFun]: false,
																												role_sub_modules:
																													obj?.role_sub_modules?.map(
																														(res) =>
																															res?.id ===
																															cont?.id
																																? {
																																		...res,
																																		[roleFun]:
																																			e.target
																																				?.checked,
																																  }
																																: res
																													),
																										  }
																										: obj
																								)
																							);
																						}}
																					/>{" "}
																					{Translate[lang][roleFun]}
																				</label>
																			);
																		})}
																	</div>
																</div>
															);
														})}
													</div>
												</div>
											</div>
										) : (
											<div>
												<div className="rul-div">
													<div className="title-bg rul-title">
														<p>{Translate[lang][rul?.displayName]}</p>
														<div className="rolesFun">
															{rolesFun?.map((roleFun) => {
																return (
																	<label className="mb-0" key={roleFun}>
																		<input
																			className={
																				lang === "en" ? "mr-2" : "me-2"
																			}
																			type="checkbox"
																			name={`${roleFun}_${rul?.text}`}
																			checked={rul[roleFun]}
																			onChange={(e) => {
																				setRolesData((prev) =>
																					prev?.map((obj) =>
																						obj.id === rul?.id
																							? {
																									...obj,
																									[roleFun]: e.target?.checked,
																							  }
																							: obj
																					)
																				);
																			}}
																		/>{" "}
																		{Translate[lang][roleFun]}
																	</label>
																);
															})}
														</div>
													</div>
												</div>
											</div>
										)}
									</Col>
								);
							})}
						</Row>
						<Row>
							<div className="col-md-6 col-12 mt-3 mb-5">
								<Button className="w-100" variant="primary" type="submit">
									{Translate[lang]?.save}
								</Button>
							</div>
						</Row>
						{/* {isExist("edit_rules") && ( */}
					</div>
				</div>
			</form>
		</>
	);
};

export default AddPermission;
